export interface Palette {
  name: string;
  bg: string;
  primary: string;
  secondary: string;
  accent: string;
  shadow: string;
}

export const DARK_SHELL_PALETTE: Palette = {
  name: 'Loading',
  bg: '#1a1a1a',
  primary: '#f0f0f0',
  secondary: '#b9b9bb',
  accent: '#d8a06f',
  shadow: 'rgba(0,0,0,0.40)',
};

declare global {
  interface Window {
    flowboardConfig?: {
      themePalettes?: Record<string, Palette>;
      [key: string]: unknown;
    };
  }
}

export function getThemePalette(themeId: string | null | undefined): Palette {
  if (!themeId) return DARK_SHELL_PALETTE;
  const map = typeof window !== 'undefined' ? window.flowboardConfig?.themePalettes : undefined;
  const hit = map?.[themeId];
  return hit || DARK_SHELL_PALETTE;
}

export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  if (h.length !== 6) return `rgba(216,160,111,${alpha})`;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function lighten(hex: string, amt: number): string {
  const h = hex.replace('#', '');
  if (h.length !== 6) return hex;
  const r = Math.min(255, parseInt(h.slice(0, 2), 16) + Math.round(255 * amt));
  const g = Math.min(255, parseInt(h.slice(2, 4), 16) + Math.round(255 * amt));
  const b = Math.min(255, parseInt(h.slice(4, 6), 16) + Math.round(255 * amt));
  return `rgb(${r}, ${g}, ${b})`;
}

export function darken(hex: string, amt: number): string {
  const h = hex.replace('#', '');
  if (h.length !== 6) return hex;
  const r = Math.max(0, parseInt(h.slice(0, 2), 16) - Math.round(255 * amt));
  const g = Math.max(0, parseInt(h.slice(2, 4), 16) - Math.round(255 * amt));
  const b = Math.max(0, parseInt(h.slice(4, 6), 16) - Math.round(255 * amt));
  return `rgb(${r}, ${g}, ${b})`;
}

export function isDarkBg(hex: string): boolean {
  const h = hex.replace('#', '');
  if (h.length !== 6) return false;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum < 0.5;
}
